import { createSlice } from "@reduxjs/toolkit";

export const lookAndFeelSlice = createSlice({
  name: 'lookAndFeel',
  initialState: {
    data: null,
    error: null,
    isLoading: false
  },
  reducers: {
    startLookAndFeel: (state) => { state.isLoading = true },
    setLookAndFeel: (state, { payload: { data, error }}) => {
      state.data = data;
      state.error = error;
      state.isLoading = false;
    }
  }
});

export const { startLookAndFeel, setLookAndFeel } = lookAndFeelSlice.actions;
